import { useEffect } from 'react';

/**
 * 自定义 Hook：动态设置网页标题
 * @param {string} title - 标题内容
 * @param {Object} options - 可选配置
 * @param {string} options.prefix - 标题前缀
 * @param {string} options.suffix - 标题后缀
 * @param {boolean} options.replace - 是否完全替换默认标题
 */
const useDocumentTitle = (title, options = {}) => {
  const {
    prefix = 'rtycn - ',
    suffix = '',
    replace = false
  } = options;

  useEffect(() => {
    if (!title) return;

    const fullTitle = replace ? title : `${prefix}${title}${suffix}`;
    document.title = fullTitle;

    // 组件卸载时恢复默认标题
    return () => {
      document.title = 'rtycn';
    };
  }, [title, prefix, suffix, replace]);
};

export default useDocumentTitle;
